<!-- AI机器人测评功能已隐藏 -->
<!-- <div class="p-d-flex p-ai-center p-jc-between" style="position: absolute;  z-index: 100;">
    <div style="position: relative;">
        <div class="robot" style="width:280px;height:200px;left:-320px;">
            <img src="assets/file/image/rbft.png" style="width: 100px;height:100px;">
            <div class="robot">
                <img class="robot-back" style="width: 100px;height:100px;" src="assets/file/image/rbfb.png" >
                <div id="robot" class="robot" style="cursor: pointer;">
                    <img src="assets/file/image/rbf.png" >
                    <div class="scan-center scan-stop" style="visibility:block;">
                        <img class="leftEye" src="assets/file/image/rbfy.png" style="margin-right:5px;">
                        <img class="rightEye" src="assets/file/image/rbfy.png" >
                    </div>
                    <div class="scan-center scan-run" style="visibility:hidden;">
                        扫描中
                    </div>
                </div>
            </div>
        </div>
        <div id="scanItems" class="scanItems" style="position:absolute;top:200px;left:-320px;width:280px;background-color: #FFFFFF;border-radius: 16px;visibility:hidden;">
            <div style="margin-top:-10px;width:280px;display:flex;justify-content: center;">
                <div style="width:0;height:0;border-bottom:20px solid #FFFFFF;border-left: 20px solid rgba(0,0,0,0);border-right: 20px solid rgba(0,0,0,0);"> </div>
            </div>
            <div class="scanChild" style="width:280px;padding:10px;background-color: #FFF;border-radius: 16px;">
                <div style="width:100%;height:34px;background: linear-gradient(95.4deg, #63E5E2 -14.47%, #0C58ED 45%, #AB1CF7 103.62%);border-radius: 8px;
                        display: flex;justify-content: space-between;align-items: center; font-size: 16px; padding: 10px; color: #FFF; font-weight: 700;">
                    <span>测评项目</span>
                    <span>风险等级</span>
                </div>
                <p-scrollPanel [style]="{width: '100%', height: '500px'}">
                    <ng-container *ngFor="let item of scanItems">
                        <div style="width:100%;font-size: 16px;margin-top:20px;border-bottom: 1px solid #EBEBEB;
                                padding-bottom: 10px;font-family: 'Source Han Sans CN'; font-style: normal; font-weight: 500;color:#000;">
                            <div>
                                <div style="font-size:16px;font-weight:500;display: flex;justify-content: space-between;align-items: center;width:100%;">
                                    <label>{{item['key']}}</label>
                                    <label [ngStyle]="{'color':  item['status'] == 1 ? riskColor[item['riskType']] : 'green' }"> 
                                        {{item['status'] == 1 ? riskType[item['riskType']] : '正常'}}
                                    </label>
                                </div>
                                <div style="font-size:14px;font-weight:500;margin-top:5px;color:#999999;">
                                     {{item['label']}}
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </p-scrollPanel>
            </div>
        </div>
    </div>
</div> -->
<!-- AI机器人测评功能已隐藏结束 -->
<div #viewComponent style="margin: 0;padding: 0;height:100%;width:100%;">
    <div class="header">
        <div>
            车辆审核
        </div>
        <div>
            <i class="pi pi-times p-cursor" (click)="closeDetail()"></i>
        </div>
    </div>
    <div class="body" style="padding: 23px 30px 0px;position: relative;">
        <table>
            <tr style="width:100%;height:100%;">
                <td class="panel-left">
                    <div class="panel-detail panel-background">
                        <div class="panel-detail-header">
                            <div class="company-name">
                                {{localTruckDetail['plateNumber']}}
                            </div>
                            <div class="company-tel">
                                <img src="assets/icon/map-location.png" alt="">&nbsp;
                                <span *ngIf="localTruckDetail['formattedAddress']">{{localTruckDetail.formattedAddress}}
                                    <span class="auditor" [pTooltip]="'定位时间：'+ this.bc.setCreateTime(localTruckDetail['addTime']*1000)" tooltipPosition="top">（{{this.bc.dateDiff(localTruckDetail['addTime']*1000)}}）</span>
                                </span>
                                <span class="auditor" *ngIf="!localTruckDetail['formattedAddress']">暂无</span>
                            </div>
                            <div class="panel-detail-status p-d-flex p-ai-center p-jc-center">
                                    <!-- <img *ngIf="localTruckDetail['plateNumber'].length==8" class="p-mr-3" pTooltip="新能源" tooltipPosition="top" src="assets/icon/tram.png" alt=""> -->
                                <div [ngClass]="localTruckDetail['useStatus'] ? 'company-permit' : 'company-status'">
                                    {{this.useStatus[localTruckDetail['useStatus']]}}
                                </div>
                                <div class="company-contract" *ngIf="localTruckDetail['checkFlag']==1">
                                    {{checkFlag[localTruckDetail['checkFlag']]}}
                                </div>
                                
                                <div class="company-success" *ngIf="localTruckDetail['checkFlag']==2">
                                    {{checkFlag[localTruckDetail['checkFlag']]}}</div>
                                <div class="company-permit" *ngIf="localTruckDetail['checkFlag']==3">
                                    {{localTruckDetail['checkLog']}}</div>

                                <div class="company-contract p-mr-3"
                                    *ngIf="bc.getExpireDays(localTruckDetail['optCertExpireTime'],'',localTruckDetail['expiredWarnDay']) > 0">
                                    道路运输证{{bc.getExpireDays(localTruckDetail['optCertExpireTime'],'',localTruckDetail['expiredWarnDay'])}}天后过期
                                </div>
                                <div class="company-permit p-mr-3"
                                    *ngIf="bc.getExpireDays(localTruckDetail['optCertExpireTime'],'',localTruckDetail['expiredWarnDay']) < 0">
                                    道路运输证已过期{{bc.getExpireDays(localTruckDetail['optCertExpireTime'],1,localTruckDetail['expiredWarnDay'])}}天
                                </div>

                                <div class="company-contract p-mr-3"
                                    *ngIf="bc.getExpireDays(localTruckDetail['businessCertificateExpireTime'],'',localTruckDetail['expiredWarnDay']) > 0">
                                    经营许可证{{bc.getExpireDays(localTruckDetail['businessCertificateExpireTime'],'',localTruckDetail['expiredWarnDay'])}}天后过期
                                </div>
                                <div class="company-permit p-mr-3"
                                    *ngIf="bc.getExpireDays(localTruckDetail['businessCertificateExpireTime'],'',localTruckDetail['expiredWarnDay']) < 0">
                                    经营许可证已过期{{bc.getExpireDays(localTruckDetail['businessCertificateExpireTime'],1,localTruckDetail['expiredWarnDay'])}}天
                                </div>
                            </div>
                        </div>
                        <div class="hr"></div>
                        <form class="detail-form" action="">
                            <div class="table-detail">
                                <div class="table-rows">
                                    <div class="table-tr">
                                        车主姓名
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['ownName']}}
                                    </div>
                                    <div class="table-tr">
                                        车辆属性
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{this.isPersonalMap[localTruckDetail['isPersonal']]}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        业户社会信用代码
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{localTruckDetail['ownCarrierId']}}
                                    </div>
                                    <div class="table-tr">
                                        挂车车牌
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['trailerPlateNumber']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        车辆类型
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{this.vehicleTypeMap[localTruckDetail['vehicleType']]}}
                                    </div>
                                    <div class="table-tr">
                                        车辆长度
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{localTruckDetail['length']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        车辆宽度
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{localTruckDetail['width']}}
                                    </div>
                                    <div class="table-tr">
                                        车辆高度
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{localTruckDetail['height']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        车辆核载
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{localTruckDetail['loadWeight']}}
                                    </div>
                                    <div class="table-tr">
                                        车辆满载
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{localTruckDetail['fullLoadWeight']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        车辆体积
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{localTruckDetail['trailerVolume']}}
                                    </div>
                                    <div class="table-tr">
                                        车辆品牌
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{localTruckDetail['model']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        车牌颜色
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{this.plateColorMap[localTruckDetail['plateColor']]}}
                                    </div>
                                    <div class="table-tr">
                                        车辆能源类型
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{this.energyTypeMap[localTruckDetail['energyType']]}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        使用性质
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{localTruckDetail['useCharacter']}}
                                    </div>
                                    <div class="table-tr">
                                        车辆识别代码
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{localTruckDetail['truckVin']}}
                                    </div>
                                </div>
                                <!-- 隐藏车型和车长字段 -->
                                <!-- <div class="table-rows">
                                    <div class="table-tr">
                                        车型
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{this.truckModelMap[localTruckDetail['truckType']]}}
                                    </div>
                                    <div class="table-tr">
                                        车长
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{this.truckSizeMap[localTruckDetail['truckSize']]}}
                                    </div>
                                </div> -->
                            </div>
                        </form>
                        <form class="detail-form" action="">
                            <div class="table-detail">
                                <div class="table-rows">
                                    <div class="table-tr">
                                        道路运输证号
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{localTruckDetail['optCertNo']}}
                                    </div>
                                    <div class="table-tr">
                                        道路运输证失效日期
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{this.bc.setCreateTime(localTruckDetail['optCertExpireTime']*1000,'yyyy-MM-dd')}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        经营许可证号
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{localTruckDetail['businessCertificate']}}
                                    </div>
                                    <div class="table-tr">
                                        经营许可证失效日期
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{this.bc.setCreateTime(localTruckDetail['businessCertificateExpireTime']*1000,'yyyy-MM-dd')}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        行驶证发证机关
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['issuingOrganizations']}}
                                    </div>
                                    <div class="table-tr">
                                        行驶证注册日期
                                    </div>
                                    <div class="table-td"*ngIf="localTruckDetail['registerDate']<=0">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['registerDate']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        行驶证发证日期
                                    </div>
                                    
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['issueDate']}}
                                    </div>
                                    <div class="table-tr">
                                        入网状况
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{this.isOnlineMap[localTruckDetail['isOnline']]}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        年检到期日期
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['vehicleExaminedExpirationDate']}}
                                    </div>
                                    <div class="table-tr">
                                        备注
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['remark']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        审核时间
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{this.bc.setCreateTime(localTruckDetail['checkTime']*1000)}}
                                    </div>
                                    <div class="table-tr">
                                        审核人员
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['checkName']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        创建时间
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{this.bc.setCreateTime(localTruckDetail['createTime']*1000)}}
                                    </div>
                                </div>
                            </div>
                        </form>
                        <form class="detail-form" action="">
                            <div class="table-title">关联信息</div>
                            <p-accordion>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">司机（{{this.relDriverList.length}}）
                                        <div *ngFor="let item of relDriverList;let i = index">
                                            <p-chip *ngIf="i<6" [label]="item['driverName']" style="margin-left: 10px;"
                                                styleClass="p-mr-2 custom-chip"></p-chip>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="content">
                                        <div class="table-rows" style="background-color: var(--surface-d)">
                                            <div class="table-line">序号</div>
                                            <div class="table-line">司机姓名</div>
                                            <div class="table-line">联系电话</div>
                                            <div class="table-line">人车照片</div>
                                        </div>
                                        <div class="table-rows" *ngIf="relDriverList.length==0">
                                            <div class="table-line" *ngIf="!loadingRelInfo">
                                                暂无数据
                                            </div>
                                            <div class="table-line" *ngIf="loadingRelInfo">
                                                <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                            </div>
                                        </div>
                                        <div class="table-rows"
                                            *ngFor="let item of relDriverList;let i = index">
                                            <div class="table-line">
                                                {{i+1}}
                                            </div>
                                            <div class="table-line">
                                                {{item.driverName}}
                                            </div>
                                            <div class="table-line">
                                                {{item.driverPhone}}
                                            </div>
                                            <div class="table-line">
                                                <ng-container
                                                    *ngIf="item.driverTruckPhoto == '' || item.driverTruckPhoto == null">
                                                    <span style="color: red;">未上传</span>
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="item.driverTruckPhoto != '' && item.driverTruckPhoto != null">
                                                    <a href="javascript:;" pRipple class="edit-font"
                                                        (click)="checkDriverTruckPhoto(item)"
                                                        style="color: #4ea844;">已上传</a>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-accordionTab>
                                <!-- 车主模块已隐藏 -->
                                <p-accordionTab>
                                    <ng-template pTemplate="header">挂靠协议</ng-template>
                                    <ng-template pTemplate="content">
                                        <div class="table-rows" style="background-color: var(--surface-d)">
                                            <div class="table-line">车牌号</div>
                                            <div class="table-line">车辆属性</div>
                                            <div class="table-line">挂靠协议</div>
                                        </div>
                                        <div class="table-rows" *ngIf="!localTruckDetail['plateNumber']">
                                            <div class="table-line" *ngIf="!loadingTruckInfo">
                                                暂无数据
                                            </div>
                                            <div class="table-line" *ngIf="loadingTruckInfo">
                                                <p-skeleton *ngIf="loadingTruckInfo"></p-skeleton>
                                            </div>
                                        </div>
                                        <div class="table-rows" *ngIf="localTruckDetail['plateNumber']">
                                            <div class="table-line">
                                                {{localTruckDetail['plateNumber']}}
                                            </div>
                                            <div class="table-line">
                                                {{this.isPersonalMap[localTruckDetail['isPersonal']]}}
                                            </div>
                                            <div class="table-line">
                                                <ng-container
                                                    *ngIf="!localTruckDetail['agreementPhoto'] || localTruckDetail['agreementPhoto'] == ''">
                                                    <span style="color: red;">未上传</span>
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="localTruckDetail['agreementPhoto'] && localTruckDetail['agreementPhoto'] != ''">
                                                    <a href="javascript:;" pRipple class="edit-font"
                                                        (click)="checkAffiliationAgreement()"
                                                        style="color: #4ea844;">已上传</a>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-accordionTab>
                            </p-accordion>
                        </form>
                    </div>
                </td>
                <td class="panel-right">
                    <div class="panel-list panel-background">
                        <div class="photo-detail">
                            <div class="img-describe">{{imgDescribe}}</div>
                            <div class="img-container">
                                <div class="img-preview">
                                    <img (click)="previewThumbnailImage()" *ngIf="imgPriview || thumbnailImageSrc.length>0"
                                        [src]="imgPriview?imgPriview:thumbnailImageSrc[0]['url']"
                                        class="img-preview-img">
                                </div>
                                <div class="function-container">
                                    <div class="function-item turnLeft" (click)="handleTurnLeft()">
                                        <img src="assets/icon/tleft.png" alt="">
                                    </div>
                                    <div class="function-item turnRight" (click)="handleTurnright()">
                                        <img src="assets/icon/tright.png" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="img-list">
                                <div class="img-list-previous">
                                    <img src="assets/icon/Vector 34.png" alt="">
                                </div>
                                <div style="margin: 0 40px;" class="p-d-flex p-ai-center p-jc-center">
                                    <ng-container *ngFor="let item of thumbnailImageSrc;let i = index;">
                                        <div class="img-list-item" [ngClass]="previewImgIndex == i? 'onactive': '' " >
                                            <img [src]="item.url" (click)="handlePreviewImgClick(item,i)" >
                                            <div class="img-describe-little-mask">
                                                <div class="img-describe-little">{{item.title}}</div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                                <div class="img-list-next">
                                    <img src="assets/icon/Vector 35.png" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="photo-detail">
                            <div class="img-describe">审核日志</div>
                            <div style="height: 250px;overflow-y: auto;">
                                <p-timeline [value]="checkList">
                                    <ng-template pTemplate="content" let-event>
                                        {{this.bc.setCreateTime(event.createTime*1000)}}
                                        <br/>
                                        {{event.creatorName}}
                                        <br/>
                                        <span [style]="{'color': this.getCheckFlag(event.status)}">{{event.remark}}</span>
                                    </ng-template>
                                    <ng-template pTemplate="opposite" let-event>
                                        <p-tag [value]="this.checkFlag[event.status]" [rounded]="true"
                                            [style]="{'background-color': this.getCheckFlag(event.status)}"></p-tag>
                                    </ng-template>
                                </p-timeline>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
        <div style="position:fixed;bottom:20px;right:30px;">
            <button pButton type="button" label="审核通过" class="p-mr-2" (click)="checkTruck(10)"></button>
            <button pButton type="button" label="审核不通过" (click)="checkTruckDialog = true"></button>
        </div>
    </div>
</div>

<p-dialog  class="edit-order" [(visible)]="checkTruckDialog" position="center"
    [dismissableMask]="false" [modal]="true" [style]="{width:'40%', overFlow:'auto'}" [draggable]="true"
    [resizable]="false">
    <ng-template pTemplate="header">
        <div >
            审核不通过 <i class="pi pi-info-circle" pTooltip="审核不通过，会默认添加扫描风险项" tooltipPosition="top"></i>
        </div>
    </ng-template>
    <form [formGroup]="checkTruckForm" style="background-color: #ffffff;border-radius: 12px;padding:24px 16px;">
        <div>
            <label for="checkLog" class="label_common">审核不通过原因</label>
            <textarea pInputTextarea formControlName="checkLog" style="width:98%"></textarea>
        </div>
        <small *ngIf="bc.checkFormItem(this.checkTruckForm, 'checkLog')" class="p-error block error-msg">
            请填写审核不通过原因
        </small>
    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="checkTruck(15)" label="确定" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消" (click)="checkTruckDialog = flase"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>

<!-- 强制审核通过 -->
<p-dialog header="中风险审核确认" class="edit-order" [(visible)]="forceCheckTruckDialog" position="center"
    [dismissableMask]="false" [modal]="true" [style]="{width:'40%', overFlow:'auto'}" [draggable]="true" [resizable]="false">
    <ng-container *ngFor="let item of scanItems">
        <div style="margin: 10px 0;">
            <label class="p-mr-2">
                {{item['key']}}:
            </label>
            <span>
                {{item['label']}}
            </span>
        </div>
    </ng-container>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="saveCheckTruck(10, '确认强制审核通过当前车辆吗？')" label="确定" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消" (click)="forceCheckTruckDialog = flase"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>

<app-common-confirm></app-common-confirm>

